import * as mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

export default{
  namespaced: true,
  state () {
    return {
      id: null,
      vendor: null,
      payer: null,
      description: null,
      totalAmount: null,
      unit: 'EUR',
      count: null,
      isCatalog: false
    }
  },
  mutations,
  getters,
  actions
}
